import { render, staticRenderFns } from "./Operadores.vue?vue&type=template&id=19fa37b6&"
import script from "./Operadores.vue?vue&type=script&lang=js&"
export * from "./Operadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports